import { Box, Pagination, styled } from '@mui/material';
import { FC, useRef } from 'react';

import { Color } from '~/constants';
import { AlertDetails } from '~/pages/AlertsList/types';
import { useAppDispatch, useAppSelector } from '~/redux-rtk/hooks';
import { AlertActions } from '~/redux-rtk/slices/alertSlice';
import { anythingHasFocus, focusPrevious } from '~/utils/focusUtils';

import ActiveAlertsCard from '../ActiveAlertsCard';

// to be removed if pagination is not required
const StyledPagination = styled(Pagination)(({ theme }) => ({
  '& .MuiPaginationItem-root': {
    borderRadius: theme.spacing(1),
  },
  '& .Mui-selected': {
    backgroundColor: Color.White,
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    '&:hover': {
      borderColor: theme.palette.primary.main,
      backgroundColor: Color.White,
    },
  },
}));
interface ActiveAlertListProps {
  alertDetails: AlertDetails;
}

const ActiveAlertList: FC<ActiveAlertListProps> = ({ alertDetails }) => {
  const dispatch = useAppDispatch();
  const alertListRef = useRef<HTMLElement>();
  const handleChange = (event, value) => {
    // If we had keyboard focus previously, we make the assumption it was within the paginated
    // results, and we don't want the keyboard focus to just be lost when we updated that data, so
    // refocus on previous element
    if (anythingHasFocus()) {
      focusPrevious(alertListRef);
    }
    dispatch(AlertActions.updateAlertPageSelected(value - 1));
  };
  const alertPageSelected = useAppSelector(
    state => state.alert.alertPageSelected,
  );

  return (
    <Box ref={alertListRef}>
      {alertDetails?.content?.map((card, index) => {
        return (
          <ActiveAlertsCard
            key={card.id + index.toString()}
            alertData={card}
            sx={{
              borderBottom: `1px solid ${Color.AntiFlashWhite}`,
              borderRadius: 0,
            }}
          />
        );
      })}
      <Box mt={2} display="flex" justifyContent="center">
        <StyledPagination
          count={Math.ceil(alertDetails?.totalPages)}
          page={alertPageSelected + 1}
          onChange={handleChange}
        />
      </Box>
    </Box>
  );
};

export default ActiveAlertList;
